export default __webpack_public_path__ + "static/media/6_three.8223a2cd.png";